var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('keys-table',{attrs:{"keys":_vm.keys,"loading":_vm.loading,"count":_vm.count},on:{"fetch-keys":_vm.getKeys}})
}
var staticRenderFns = []

export { render, staticRenderFns }